// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"search-list_wrapper__i_m_4","noBoards":"search-list_noBoards__g6_UC","recentTitle":"search-list_recentTitle__n0TU0"};